"use client";

import type { JSX } from "react";
import { Toaster as SonnerToaster } from "sonner";

export function Toaster(): JSX.Element {
  return (
    <SonnerToaster
      expand={false}
      visibleToasts={3}
      position="bottom-right"
      richColors
      toastOptions={{
        classNames: {
          toast: "border rounded-md shadow-lg",
          title: "text-sm font-semibold",
          description: "text-xs opacity-90",
        },
      }}
      icons={{
        success: null,
        info: null,
        warning: null,
        error: null,
        loading: null,
      }}
    />
  );
}
